export default [
  {
    content: {
      title: '<span class="title__line"><span class="title__letter">D</span><span class="title__letter">I</span><span class="title__letter">E</span><span class="title__letter">S</span><span class="title__letter">E</span><span class="title__letter">L</span></span><br /><span class="title__line"><span class="title__letter">W</span><span class="title__letter">Y</span><span class="title__letter">N</span><span class="title__letter">W</span><span class="title__letter">O</span><span class="title__letter">O</span><span class="title__letter">D</span></span>',
    },
  },
  {
    content: {
      image: '/static/images/real_estate/diesel_wynwood_img1.jpg',
      eyelet: 'Diesel Wynwood Condominium',
    },
  },
  {
    content: {
      subtitle: 'Miami’s Wynwood district is home to the largest, most ambitious project yet from Diesel Living, developed by Bel Invest.',
      text: 'A vision of what metropolitan life can be. Enriched by a host of comforts, among which boasts a contemporary pool, gym, meditation room, a curated art gallery as well a lush courtyard, Diesel Wynwood’s concrete and golden elements are finely complemented by the building’s tropical greenery.<br />The essence of Diesel: a total luxury space of comfort and cutting-edge design.',
    },
  },
  {
    content: {
      title: '<span class="title__line">A SYMBIOSIS</span><br /><span class="title__line">OF NATURE</span><br /><span class="title__line">AND CITY FOR THE</span><br /><span class="title__line">MODERN LIFE</span><br /><span class="title__line">OF CONTEMPORARY</span><br /><span class="title__line">URBAN DWELLERS.</span>',
    },
  },
  {
    content: [
      {
        title: 'The Neighborhood?',
        text: 'Wynwood is one of the coolest aereas in the U.S.A. Cushman & Wakefield attest such. But we’re certain a stroll around the block will have you feel the same.',
      },
      {
        title: 'Nature and City',
        text: 'Bringing light and nature to living spaces. A contemporary residence where the surrounding post-industrial scape merges with the nearness of nature.',
      },
    ],
  },
  {
    content: {
      image: '/static/images/real_estate/diesel_wynwood_img2.jpg',
      is3d: true,
      eyelet: 'Diesel Wynwood - 360° Experience',
    },
  },
  {
    content: {
      title: 'DIESEL WYNWOOD',
      text: 'In line with the extraordinary development of Wynwood, the city recently emitted a new zoning plan, which will make Wynwood become the most urban and pedestrian friendly neighbourhood of the city. The new Soho of Miami.<br />143 uniquely designed spaces rendered in a light or dark key according to their building orientation ranging from Studio to Penthouses and Maisonettes.',
    },
  },
  {
    content: {
      title: 'DIESEL WYNWOOD - PRE-SALE SEASON',
    },
  },
  {
    content: [
      {
        content: {
          image: '/static/images/real_estate/diesel_wynwood_img3.jpg',
          title: 'APT. A1-L4.<br />STUDIO<br />395 SQ.FT',
          price: '$ 399.000',
        },
      },
      {
        content: {
          image: '/static/images/real_estate/diesel_wynwood_img4.jpg',
          title: 'APT. D6-L4<br />2 BDRM<br />1.118 SQ.FT',
          price: '$ 949.000',
        },
      },
      {
        content: {
          image: '/static/images/real_estate/diesel_wynwood_img5.jpg',
          title: 'APT. E4-L4<br />2 BDRM + DEN<br />1.467 SQ.FT',
          price: '$ 1.399.000',
        },
      },
    ],
  },
  {
    content: {
      image: '/static/images/real_estate/diesel_wynwood_img6.jpg',
    },
  },
  {
    content: [
      {
        content: {
          image: '/static/images/real_estate/diesel_wynwood_img7.jpg',
          title: 'APT. F1-L6<br />3 BDRM<br />1.538 SQ.FT',
          price: '$ 1.599.000',
        },
      },
      {
        content: {
          image: '/static/images/real_estate/diesel_wynwood_img8.jpg',
          title: 'APT. F2-L8<br />PENTHOUSE<br />3.021 SQ.FT',
          price: '$ 5.500.000',
        },
      },
    ],
  },
  {
    content: {
      title: 'DIESEL WYNWOOD - PRE-SALE SEASON',
    },
  },
  {
    content: {
      title: '<span class="title__line">NATURE AND THE</span><br /><span class="title__line">POST-INDUSTRIAL</span><br /><span class="title__line">LANDSCAPE</span><br /><span class="title__line">INTO A DYNAMIC</span><br /><span class="title__line">MODERN AESTHETIC</span>',
    },
  },
  {
    content: {
      subtitle: 'People desire a more urban lifestyle, without compromises. Diesel Wynwood is the answer.',
      text: 'Art and business, hotels, thriving New Economy offices, exciting retail, fancy restaurants as well as other residentials and thrilling entertainment. These are just some of the elements of the face of Wynwood’s new, vibrant street life. A unique home that brings together the most skillful, future focused and imaginative individuals to live in this modern enclave.',
    },
  },
  {
    content: {
      image: '/static/images/real_estate/diesel_wynwood_img9.jpg',
    },
  },
  {
    content: {
      title: '<span class="title__line"><span class="title__letter">C</span><span class="title__letter">O</span><span class="title__letter">N</span><span class="title__letter">T</span><span class="title__letter">A</span><span class="title__letter">C</span><span class="title__letter">T</span></span>',
    },
  },
];
